import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import DayPicker from 'react-day-picker'

import TeamMembersFilter from './workers/TeamMembersFilter'
import GCalIntegration from './gcal/GCalIntegration'

const WEEK_START_TYPE = 'week'

export default class ScheduleOptionsPanel extends React.Component {

  static propTypes = {
    dateStr: PropTypes.string.isRequired,
    viewMode: PropTypes.string,
    onDayClicked: PropTypes.func.isRequired,
    onSelectedWorkersChanged: PropTypes.func.isRequired
  }

  getDayPickerModifiers = () => {
    return {
      sameWeek: day => {
        // Show these days only if the selected mode is week
        if (this.props.viewMode !== 'week') {
          return false
        }
        // Return false with the selected day
        const dayMoment = moment(day)
        if (this.props.dateStr === dayMoment.format('YYYY-MM-DD')) {
          return false
        }
        // Return true for any day for the selected week
        const startOfDayWeek = dayMoment.startOf(WEEK_START_TYPE)
        const startOfDayWeekState = moment(this.props.dateStr)
          .startOf(WEEK_START_TYPE)
        return startOfDayWeek.isSame(startOfDayWeekState)
      }
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <DayPicker
            fixedWeeks={true}
            firstDayOfWeek={0}
            onDayClick={this.props.onDayClicked}
            month={moment(this.props.dateStr).toDate()}
            selectedDays={moment(this.props.dateStr).toDate()}
            modifiers={this.getDayPickerModifiers()}
            modifiersStyles={styles.dayPickerModifiers} />
          <TeamMembersFilter
            style={{ marginTop: 20 }}
            onSelectedWorkersChanged={this.props.onSelectedWorkersChanged} />
          <GCalIntegration />
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    // overflow properties for scrolling on a large list of workers
    minWidth: 240,
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#f7f7f7',
    borderRightStyle: 'solid',
    borderRightWidth: 1,
    borderRightColor: '#D3D3D3'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: 18
  },
  dayPickerModifiers: {
    sameWeek: {
      background: '#dbefff'
    }
  }
}



// WEBPACK FOOTER //
// ./src/schedule/ScheduleOptionsPanel.js